import React, { useEffect, useRef } from "react";

// Soft gold spotlight that trails the cursor. Purely decorative: fixed,
// pointer-events:none, and skipped entirely on touch/coarse-pointer devices.
function CursorGlow() {
  const glowRef = useRef(null);

  useEffect(() => {
    const glow = glowRef.current;
    if (!glow) return;

    // No cursor to follow on touch devices — leave the DOM node inert.
    const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (!finePointer.matches) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    let raf = null;
    let tx = 0;
    let ty = 0;
    let cx = -500;
    let cy = -500;
    let visible = false;

    const paint = () => {
      glow.style.transform =
        "translate(" + cx + "px, " + cy + "px) translate(-50%, -50%)";
    };

    const tick = () => {
      cx += (tx - cx) * 0.15;
      cy += (ty - cy) * 0.15;
      paint();
      // Park the loop once we've effectively caught up to the pointer.
      if (Math.abs(tx - cx) > 0.5 || Math.abs(ty - cy) > 0.5) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = null;
      }
    };

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;

      if (!visible) {
        // First move: jump to the pointer before fading in, so the glow never
        // appears parked in the top-left corner.
        visible = true;
        cx = tx;
        cy = ty;
        paint();
        glow.classList.add("is-visible");
        return;
      }

      if (reduceMotion) {
        cx = tx;
        cy = ty;
        paint();
        return;
      }

      if (!raf) raf = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", onMove);
    return () => {
      window.removeEventListener("mousemove", onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return <div className="edge-cursor-glow" ref={glowRef} aria-hidden="true" />;
}

export default CursorGlow;
